<ng-container *ngIf="!isLoading; else loadingTemplate">
  <ng-container *ngIf="responses && responses.length > 0; else noTableData">
    <div class="text-center mb-4 fw-200">{{ totalResponses }} Submissions</div>
    <div class="card text-card">
      <div
        class="text-answer"
        *ngFor="let response of responses; let i = index">
        <div id="response-{{ fieldId }}-{{ i }}" class="response-container">
          <div
            *ngIf="hasOverflow(i)"
            (click)="openResponseModal(response.text_answer)"
            class="overflow-button text-end">
            <button type="button" class="btn link-text fs-12 fw-600">
              <i class="bi bi-eye me-2"></i>View Full Response
            </button>
          </div>
          <app-safehtml
            html="{{ response.text_answer }}"
            [removeMargin]="true"></app-safehtml>
        </div>
      </div>
    </div>
  </ng-container>
</ng-container>

<ng-template #loadingTemplate>
  <div class="w-100" style="height: 300px; position: relative">
    <app-loader />
  </div>
</ng-template>

<ng-template #noTableData>
  <div class="text-center py-3">No Responses Found.</div>
</ng-template>

<section>
  <div class="d-flex justify-content-center my-4">
    <ngb-pagination
      *ngIf="totalResponses > 10"
      [(page)]="currentPage"
      [pageSize]="10"
      [collectionSize]="totalResponses"
      [maxSize]="5"
      (pageChange)="paginationChange()"></ngb-pagination>
  </div>
</section>

<app-modal #responseModal>
  <button
    class="bg-transparent border-0"
    title="Close"
    aria-label="close"
    headerContent
    (click)="responseModal.close()">
    <i class="bi bi-x-lg text-white"></i>
  </button>
  <div class="p-3">
    <app-safehtml class="show-all" html="{{ modalResponse }}"></app-safehtml>
  </div>
</app-modal>
